<template>
  <div class="login-form-wrapper">
    <!--    <div class="arrow-container-3">-->
    <!--      <a @click="goToBack"-->
    <!--      >-->
    <!--        <img src="@/assets/timeslot-images/left-arrow.svg"/>-->
    <!--      </a>-->
    <!--    </div>-->
    <div
      class="text-block-4"
      style="font-family: 'Galano grotesque-Medium', sans-serif;"
    >
      Already have an account?
      <router-link to="/login" class="link">Login</router-link>
    </div>
    <div class="div-block-20">
      <div class="div-block login">
        <div class="text-block">Get started 👋</div>
        <div class="text-block-3">
          Enter your country code and phone number
        </div>
      </div>
      <div class="div-block">
        <FormulateForm>
          <div class="phone-number-code">
            <div class="code">
              <FormulateInput
                type="select"
                validation="required"
                name="countryCode"
                validation-name="Country code"
                placeholder="Country code"
                :options="codes"
                v-model="countryCode"
              />
            </div>
            <div class="phone-no">
              <FormulateInput
                type="text"
                validation="required"
                name="phone"
                placeholder="Phone number"
                validation-name="Phone number"
                v-model="phone"
              />
            </div>
          </div>
        </FormulateForm>

        <div class="div-block-2-copy password"></div>
        <FormulateInput type="submit" label="Proceed" @click="goToNext" />
      </div>
    </div>
    <div class="text-block-2">© {{ currentYear() }} Timeslate</div>
  </div>
</template>

<script>
import { countryCodes } from "@/utils/country/countryCodes";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";

export default {
  name: "TimeslotPhoneNumberForm",
  data() {
    return {
      phone: "",
      countryCode: ""
    };
  },
  computed: {
    codes() {
      return countryCodes.map(data => {
        return {
          label: `${data.name}:${data.dial_code}`,
          value: data.dial_code,
          id: data.code
        };
      });
    }
  },
  methods: {
    currentYear() {
      let current_date = new Date();
      let current_year = current_date.getFullYear();
      return current_year;
    },
    goToBack() {
      RouterUtils.goBackOnce();
    },
    goToNext() {
      if (this.phone && this.countryCode) {
        StoreUtils.commit("auth/setUserCountryCode", this.countryCode);
        StoreUtils.commit("auth/setUserPhoneNo", this.phone);
        RouterUtils.changeRouteUrlTo("/enrollment");
      }
    }
  }
};
</script>

<style scoped>
.phone-number-code {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.code {
  width: 40%;
}
.phone-no {
  width: 58%;
}
</style>
